import { p as promiseResolve, b as bootstrapLazy } from './index-81d669ae.js';

/*
 Stencil Client Patch Esm v2.5.2 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-qrcode", [[1, "deckgo-qrcode", {
      "content": [1],
      "type": [1],
      "qrCellSize": [2, "qr-cell-size"],
      "qrMargin": [2, "qr-margin"],
      "qrBackgroundColor": [1, "qr-background-color"],
      "qrFillColor": [1, "qr-fill-color"],
      "qrAlt": [1, "qr-alt"],
      "generate": [64]
    }]]]], options);
  });
};
export { defineCustomElements };